<template>
  <div class="small strong d-flex justify-content-end align-items-center mr-30 mb-5 gap-5">
    <i
      v-if="tooltip"
      v-tooltip="tooltipOptions"
      :title="tooltip"
      class="hi hi-info-filled hi-12"
    />
    <span>Engagement</span>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsNavigationEngagement',
  data: () => ({
    tooltip: INSIGHTS.tooltips.engagementScore.content,
    tooltipOptions: Object.freeze({
      html: true,
      sanitize: false,
      placement: 'left',
      template: INSIGHTS.tooltips.engagementScore.template,
    }),
  }),
};
</script>
